import { motion } from "framer-motion";
import { Award, Target as TargetIcon, Eye } from "lucide-react";
import AnimatedCounter from "./AnimatedCounter";
import { stats } from "../lib/data";

export default function About() {
  return (
    <section id="about" className="relative py-28 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative rounded-3xl overflow-hidden glass-strong">
            <img
              src="https://images.pexels.com/photos/19746166/pexels-photo-19746166.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Wealthoo financial advisor"
              className="w-full h-[520px] object-cover opacity-90"
              data-testid="about-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/40 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 glass-strong rounded-2xl p-4 flex items-center gap-3">
              <Award className="w-8 h-8 text-blue-400" />
              <div>
                <div className="text-xs uppercase tracking-widest text-slate-400">Certification</div>
                <div className="font-bold">AMFI Registered Distributor · ARN 162408</div>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="lg:col-span-7">
          <span className="section-label">About Wealthoo</span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tighter mt-5">
            A fintech-first, advisory-led wealth partner
          </h2>
          <p className="mt-6 text-slate-400 text-base sm:text-lg leading-relaxed">
            Wealthoo Fintech Pvt. Ltd. is a Raipur-headquartered mutual fund distribution and advisory firm empowering
            investors and partner advisors with cutting-edge technology, deep research and 24×7 support. We help
            families compound their savings into life-changing wealth.
          </p>

          <div className="grid sm:grid-cols-2 gap-5 mt-8">
            <div className="glass rounded-2xl p-5">
              <TargetIcon className="w-6 h-6 text-blue-400 mb-3" />
              <h4 className="font-bold mb-1.5">Our Mission</h4>
              <p className="text-sm text-slate-400">
                Mobilise savings into the financial market through a technology-driven ecosystem that creates wealth
                for clients and partners.
              </p>
            </div>
            <div className="glass rounded-2xl p-5">
              <Eye className="w-6 h-6 text-indigo-400 mb-3" />
              <h4 className="font-bold mb-1.5">Our Vision</h4>
              <p className="text-sm text-slate-400">
                To become a world-class organisation creating the greatest value for our investors, customers and
                stakeholders.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mt-10">
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="glass-strong rounded-2xl p-5"
                data-testid={`about-stat-${i}`}
              >
                <div className="text-3xl font-black gradient-text">
                  <AnimatedCounter value={s.value} suffix={s.suffix} />
                </div>
                <div className="text-xs text-slate-400 mt-2 uppercase tracking-wider">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
